import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';

export default {
	get(): boolean {
		return expVal('jira_browse_agent_modal_update', 'isEnabled', false);
	},
};
